import { hasIban } from '../../utils';
import { useAccountIbansTransformApi } from '../api';

export const useAccountIbansHasIbans = () => {
  const hasIbansApiResponse = useAccountIbansTransformApi({
    transformFunction: hasIban,
  });
  return hasIbansApiResponse;
};
